// Same widths as the medium-screen and small-screen mixins.
const SMALL_SCREEN = '(max-width: 500px)';
const MEDIUM_SCREEN = '(max-width: 768px)';

function matchesScreen(query) {
  return typeof window.matchMedia === 'function' && window.matchMedia(query).matches === true;
}

// The breakpoint whose values show: a preview class first, then the window's own width.
export function findPreviewBreakpoint(element) {

  if (element === null || typeof element === 'undefined') {
    return 'desktop';
  }

  if (element.closest('.mobile-preview-small') !== null || matchesScreen(SMALL_SCREEN) === true) {
    return 'mobile';
  }

  if (element.closest('.mobile-preview-medium') !== null || matchesScreen(MEDIUM_SCREEN) === true) {
    return 'tablet';
  }

  return 'desktop';

}
